import { Dialog, DialogContent, Icons } from '@commenda/kakashi';
import { ServiceRequestDetails } from '@commenda/types/src/service-request/types';
import { LegacyDocumentType } from '@prisma/client';
import { Dispatch, SetStateAction } from 'react';
import { viewUploadedFile } from '../../../utils';

type EINDetailsModalProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  serviceRequest: ServiceRequestDetails;
};

export const EINDetailsModal = ({
  isOpen,
  setIsOpen,
  serviceRequest,
}: EINDetailsModalProps) => {
  const corporationEINProof =
    serviceRequest?.corporation?.corporationDocuments?.find(
      (eachFile) => eachFile?.documentType === LegacyDocumentType.EINScreenshot
    );

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="p-6 flex flex-col gap-4">
        <div className="w-12 h-12 rounded-md bg-bg-primary border border-primary flex justify-center items-center">
          <Icons.File04 className="text-fg-secondary" />
        </div>
        <h3 className="text-lg-bold text-text-primary-900 mt-4">
          View EIN Proof
        </h3>
        <div className="mt-5 flex flex-col gap-5">
          <div className="bg-bg-secondary rounded-md">
            <div className="flex flex-col gap-2 py-3 px-4">
              <p className="text-sm-medium text-text-quaternary">EIN Number</p>
              <p className="text-sm-medium text-text-primary">
                {serviceRequest?.corporation?.federalEIN}
              </p>
            </div>
          </div>
          <div className="bg-bg-secondary rounded-md">
            <div className="flex flex-col gap-2 py-3 px-4">
              <p className="text-sm-medium text-text-quaternary">EIN Proof</p>
              <p
                className="txt-small-bold text-utility-blue-600 flex items-center gap-1 cursor-pointer"
                onClick={() =>
                  viewUploadedFile(corporationEINProof?.files?.[0]?.id)
                }
              >
                Open document <Icons.ArrowUpRight className="size-4" />
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
